export const CUSTOMERS_TYPES = {
  REQUEST_CUSTOMERS: 'REQUEST_CUSTOMERS',
  STORE_CALL_ID: 'STORE_CALL_ID',
  RESTORE_CALL_ID: 'RESTORE_CALL_ID', 
  CATCH_AMAZON_CALL: 'CATCH_AMAZON_CALL',
  GET_CUSTOMERS: 'GET_CUSTOMERS',
  NEW_CUSTOMER: 'NEW_CUSTOMER',
  SET_NEW_CUSTOMER: 'SET_NEW_CUSTOMER',
  STATIONS_AVAILABLE: 'STATIONS_AVAILABLE',
  EDIT_CUSTOMER: 'EDIT_CUSTOMER',
  EDIT_CUSTOMER_INFO: 'EDIT_CUSTOMER_INFO',
  REQUEST_CUSTOMER_DATA: 'REQUEST_CUSTOMER_DATA',
  GET_CUSTOMER_DATA: 'GET_CUSTOMER_DATA',
  SELECT_CUSTOMER: "SELECT_CUSTOMER",
  RESET_CUSTOMER: "RESET_CUSTOMER",
  SELECT_CUSTOMER_ACCOUNT: "SELECT_CUSTOMER_ACCOUNT",
  SELECT_ONLY_CUSTOMER_ACCOUNT: "SELECT_ONLY_CUSTOMER_ACCOUNT",
  SELECT_VIEW: "SELECT_VIEW",
  ADD_ACCOUNT_MODE: "ADD_ACCOUNT_MODE",
  NEW_CUSTOMER_MODE: "NEW_CUSTOMER_MODE",
  REGISTER_CUSTOMER: "REGISTER_CUSTOMER",
  CLEAN_CUSTOMER: "CLEAN_CUSTOMER",
  EDIT_ACCOUNT: "EDIT_ACCOUNT",
  NEW_ACCOUNT: "NEW_ACCOUNT",
  GET_CUSTOMER_SERVICES: "GET_CUSTOMER_SERVICES",
  NEW_CUSTOMER_SERVICES: "NEW_CUSTOMER_SERVICES",
  REQUEST_CUSTOMER_SERVICES: "REQUEST_CUSTOMER_SERVICES",
  SET_SERVICE: "SET_SERVICE",
  SET_SCHEDULES: "SET_SCHEDULES",
  SET_CYCLE_DATE_SCHEDULES: "SET_CYCLE_DATE_SCHEDULES",
  SET_PRODUCTS: "SET_PRODUCTS",
  GET_CUSTOMER_CYCLES: "GET_CUSTOMER_CYCLES",
  SELECT_CYCLE: "SELECT_CYCLE",
  ADD_CYCLE_MODE: "ADD_CYCLE_MODE",
  CREATE_CYCLE: "CREATE_CYCLE",
  DELETE_ACCOUNT_CYCLE: "DELETE_ACCOUNT_CYCLE",
  EDIT_ACCOUNT_CYCLE: "EDIT_ACCOUNT_CYCLE",
  CANCEL_CYCLE_MODE: "CANCEL_CYCLE_MODE",
  GET_CUSTOMER_CONDITIONS: "GET_CUSTOMER_CONDITIONS",
  SET_CUSTOMER_CONDITIONS: "SET_CUSTOMER_CONDITIONS", // actualiza customerConditions en el store sin volver a consultar el backend
  ADD_CUSTOMER_CONDITION: "ADD_CUSTOMER_CONDITION",
  DELETE_CUSTOMER_CONDITION: "DELETE_CUSTOMER_CONDITION",
  EDIT_CONDITION_MODE: "EDIT_CONDITION_MODE",
  EDIT_CUSTOMER_CONDITION: "EDIT_CUSTOMER_CONDITION",
  GET_CUSTOMER_CONTRACTS: "GET_CUSTOMER_CONTRACTS",
  HIDE_COSTS: "HIDE_COSTS",
  START_LOADING_CONTRACT: "START_LOADING_CONTRACT",
  STOP_LOADING_CONTRACT: "STOP_LOADING_CONTRACT",
  SET_AMAZON_CONNECT: "SET_AMAZON_CONNECT",
  OPEN_AMAZON_CONNECT: "OPEN_AMAZON_CONNECT",
  CLEAN_CUSTOMERS: "CLEAN_CUSTOMERS",
  CLEAN_CUSTOMER_DETAIL: "CLEAN_CUSTOMER_DETAIL",
  RESTORE_INITIAL: "RESTORE_INITIAL",
  SET_MAP_INFO: "SET_MAP_INFO",
  SET_STATIONS_BY_TOKEN: "SET_STATIONS_BY_TOKEN",
  SET_ACCOUNT_CREDIT: "SET_ACCOUNT_CREDIT",
  SET_PUBLIC_ACCOUNT_PRODUCTS: "SET_PUBLIC_ACCOUNT_PRODUCTS",
  SET_VALID_COUPON: "SET_VALID_COUPON",
  ERROR_CUSTOMER_CREDIT: "ERROR_CUSTOMER_CREDIT",
  SET_DISCOUNT_TYPE: "SET_DISCOUNT_TYPE",
}